import { useAuth } from '../contexts/AuthContext';
import { useSuperAdminCompany } from '../contexts/SuperAdminCompanyContext';
import { useResellerCompany } from '../contexts/ResellerCompanyContext';
import { RESELLER_ALL_TENANT_ID } from '../utils/resellerCompany';

/**
 * Single source of truth for "am I looking at a merged, multi-company view?" — true
 * when a SUPERADMIN is in All-Companies mode OR a reseller has picked "All my companies".
 * In either case list rows span multiple tenants, so pages show the Company column and a
 * company filter. Replaces the `user?.role === 'SUPERADMIN' && scope.mode === 'all'`
 * expression that used to be duplicated on every page.
 */
export function useCompanyScope() {
  const { user } = useAuth() as { user: any };
  const { scope } = useSuperAdminCompany();
  const { viewedCompany } = useResellerCompany();

  const superAdminAll = user?.role === 'SUPERADMIN' && scope.mode === 'all';
  const resellerAll = !!user?.isReseller && viewedCompany?.tenantId === RESELLER_ALL_TENANT_ID;
  const showCompanyColumn = superAdminAll || resellerAll;

  return { showCompanyColumn, superAdminAll, resellerAll };
}

export default useCompanyScope;
